import { render, staticRenderFns } from "./HomeWorkV2.vue?vue&type=template&id=003aeb8a&scoped=true"
import script from "./HomeWorkV2.vue?vue&type=script&lang=js"
export * from "./HomeWorkV2.vue?vue&type=script&lang=js"
import style0 from "./HomeWorkV2.vue?vue&type=style&index=0&id=003aeb8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003aeb8a",
  null
  
)

export default component.exports